import React, { useEffect, useRef, useState } from "react";

export default function EditorHeader({
	studentName,
	students = null,
	currentStudentId = null,
	onSwitchStudent = null,
	trainingName,
	isTemplate,
	hasTraining = false,
	hasActions = true,
	headerExtra = null,
	onHistorique,
	onDupliquer,
	onPlanifier,
}) {
	const [pickerOpen, setPickerOpen] = useState(false);
	const [search, setSearch] = useState("");
	const pickerRef = useRef(null);
	const canSwitch = Array.isArray(students) && students.length > 0 && typeof onSwitchStudent === "function";

	useEffect(() => {
		if (!pickerOpen) return;
		const onClick = (e) => { if (pickerRef.current && !pickerRef.current.contains(e.target)) setPickerOpen(false); };
		const onKey = (e) => { if (e.key === "Escape") setPickerOpen(false); };
		document.addEventListener("mousedown", onClick);
		document.addEventListener("keydown", onKey);
		return () => {
			document.removeEventListener("mousedown", onClick);
			document.removeEventListener("keydown", onKey);
		};
	}, [pickerOpen]);

	const filtered = canSwitch
		? students.filter((s) => {
			const q = search.trim().toLowerCase();
			if (!q) return true;
			return `${s.prenom || ""} ${s.nom || ""}`.toLowerCase().includes(q);
		})
		: [];

	return (
		<header className="editor-header">
			<div className="editor-header-crumb">
				{studentName && (
					<>
						{canSwitch ? (
							<div className="editor-header-student-wrap" ref={pickerRef}>
								<button
									type="button"
									className="editor-header-student-btn"
									onClick={() => setPickerOpen((v) => !v)}
									title="Changer d'élève"
								>
									<span className="editor-header-crumb-segment">{studentName}</span>
									<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 4, opacity: 0.6 }}>
										<polyline points="6 9 12 15 18 9" />
									</svg>
								</button>
								{pickerOpen && (
									<div className="editor-header-student-popover">
										<input
											type="text"
											autoFocus
											value={search}
											onChange={(e) => setSearch(e.target.value)}
											placeholder="Rechercher…"
											className="editor-header-student-search"
										/>
										<div className="editor-header-student-list">
											{filtered.length === 0 ? (
												<div className="editor-header-student-empty">Aucun résultat</div>
											) : filtered.map((s) => (
												<button
													key={s.id}
													type="button"
													className={`editor-header-student-item ${s.id === currentStudentId ? "active" : ""}`}
													onClick={() => {
														setPickerOpen(false);
														setSearch("");
														if (s.id !== currentStudentId) onSwitchStudent(s);
													}}
												>
													<span>{s.prenom} {s.nom}</span>
													{s.id === currentStudentId && <span className="editor-header-student-check">✓</span>}
												</button>
											))}
										</div>
									</div>
								)}
							</div>
						) : (
							<span className="editor-header-crumb-segment">{studentName}</span>
						)}
						<span className="editor-header-crumb-sep">/</span>
					</>
				)}
				<span className={`editor-header-crumb-current ${!trainingName ? "muted" : ""}`}>
					{trainingName || "Aucune séance ouverte"}
				</span>
				{isTemplate && <span className="editor-header-badge">TEMPLATE</span>}
			</div>

			{hasTraining && hasActions && (
				<div className="editor-header-actions">
					<button className="editor-header-btn" onClick={onHistorique} title="Historique" disabled={!onHistorique}>
						Historique
					</button>
					<button className="editor-header-btn" onClick={onDupliquer}>
						Dupliquer
					</button>
					<button className="editor-header-btn editor-header-btn-primary" onClick={onPlanifier}>
						Planifier
					</button>
				</div>
			)}

			{hasTraining && !hasActions && headerExtra && (
				<div className="editor-header-actions">{headerExtra}</div>
			)}
		</header>
	);
}
